import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import { IconSizes } from "atoms/constants/icon-sizes";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import { Casi } from "constants/app-name-tm";
import NoResultsBanner from "molecules/banners/no-results-banner";
import React from "react";
import { useBookviewTabPanel } from "utilities/contexts/bookview-tab-panel/use-bookview-tab-panel";
import { useChatModal } from "utilities/hooks/domain/chat/use-chat-modal";
import useAiChatEnabled from "utilities/hooks/use-ai-chat-enabled";
import { t } from "utilities/localization-utils";

const BASE_CLASS_NAME = "c-bookview-search-panel-no-results";

interface Props {
    onClear: () => void;
    isInLegacyPublicationView?: boolean;
}

const BookviewSearchPanelNoResults: React.FC<Props> = ({
    onClear,
    isInLegacyPublicationView,
}) => {
    const { enableAIChat } = useAiChatEnabled();
    const { toggleBookviewChatPanel } = useBookviewTabPanel();
    const { openChatModal } = useChatModal();

    const casiMessage = t("bookview-search-no-results", { casi: Casi });
    const noCasiMessage = t("bookview-search-no-results-no-casi");

    return (
        <section aria-live="polite" role="status" className={BASE_CLASS_NAME}>
            <NoResultsBanner
                subtitle={enableAIChat ? casiMessage : noCasiMessage}
                title={t("noSearchResultsBanner-title")}
            />
            <div className={`${BASE_CLASS_NAME}__actions`}>
                {enableAIChat && (
                    <>
                        <Button
                            onClick={
                                isInLegacyPublicationView
                                    ? openChatModal
                                    : toggleBookviewChatPanel
                            }
                            style={ButtonStyles.Secondary}
                            cssClassName={`${BASE_CLASS_NAME}__button -casi`}
                            accessibleText={t("tryCasi")}>
                            <Icon type={Icons.Casi} size={IconSizes.Large} />
                            {t("tryCasi")}
                        </Button>
                    </>
                )}

                <Button
                    onClick={onClear}
                    style={ButtonStyles.Secondary}
                    cssClassName={`${BASE_CLASS_NAME}__button`}
                    accessibleText={t("tryAgain")}>
                    {t("tryAgain")}
                </Button>
            </div>
        </section>
    );
};

export default BookviewSearchPanelNoResults;
